module.exports = __webpack_public_path__ + "img/empty.4e820be0.svg";